import React, { ReactNode } from 'react';
import FluzLogo from '../../assets/images/fluz-icons/Logo.png';
import DeviceInHand from '../../assets/images/background-images/deviceInHand.png';
import { isMobileOrTabletBrowser } from '../../utils/device';
import { RootStateOrAny, useSelector } from 'react-redux';

interface AppWrapperProps {
  children: ReactNode;
  wrapperClassName?: string;
  isLoginScreen?: boolean;
  hideSideImage?: boolean;
}

/** Generic wrapper used for all views except the initial Login view. */
export default function AppWrapper({
  children,
  wrapperClassName = '',
  isLoginScreen = false,
  hideSideImage = false,
}: AppWrapperProps) {
  const { isIframe } = useSelector((state: RootStateOrAny) => state.auth);

  return !isMobileOrTabletBrowser() ? (
    <div data-state={isIframe ? 'iframe' : 'standalone'} className="desktop-wrapper">
      <div className={`side-gradient-container ${hideSideImage ? 'd-none' : ''}`}>
        <img src={FluzLogo} className="fluz-logo" />
        <img src={DeviceInHand} className="device-in-hand" />
      </div>
      <div className="page-background">
        <div className={`container-fluid card-container ${wrapperClassName}`}>
          <div className="card-group">{children}</div>
        </div>
      </div>
    </div>
  ) : isLoginScreen ? (
    <>{children}</>
  ) : (
    <>
      <div data-state={isIframe ? 'iframe' : 'standalone'} className="page-background">
        <div className={`container-fluid card-container ${wrapperClassName} `}>
          <div className="card-group">{children}</div>
        </div>
      </div>
    </>
  );
}
